module.exports = __webpack_public_path__ + "static/media/pMATIC.1a3fe2b4.svg";